import React, { useMemo } from 'react';
import { formatAmount, resolveFractionDigits } from 'utils/formatting';
import { useAppSelector } from 'store/hooks';
import BlurAmountView from './BlurAmountView';
import Text from './Text';
const NON_BREAKING_CHAR = '\u2060';
const Amount = ({ value, showSign, scramblable = true, showFraction = true, fractionDigits, suffix, removeZero = false, forceScramble, ...textProps }) => {
    const scrambled = useAppSelector((store) => store.utils.scrambled);
    const amount = 'amount' in value ? value.amount : value.value;
    const formatted = useMemo(() => {
        const defaultFractionDigits = showFraction ? 2 : undefined;
        return formatAmount(amount, value.currency || undefined, fractionDigits !== undefined
            ? resolveFractionDigits(amount, fractionDigits)
            : defaultFractionDigits, undefined, removeZero);
    }, [amount, value.currency, fractionDigits, showFraction, removeZero]);
    const text = suffix ? `${formatted} ${suffix}` : formatted;
    return scramblable && (scrambled || forceScramble) ? (<BlurAmountView enabled>
      <Text {...textProps}>
        {showSign && amount > 0 ? `+${NON_BREAKING_CHAR}` : null}
        {text}
      </Text>
    </BlurAmountView>) : (<Text {...textProps}>
      {showSign && amount > 0 ? `+${NON_BREAKING_CHAR}` : null}
      {text}
    </Text>);
};
export default Amount;
